import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" fillRule="evenodd" xmlns="http://www.w3.org/2000/svg" {...props}><path clipRule="evenodd" d="M16 7v10a2 2 0 01-2 2H6a2 2 0 01-2-2V7H2V3h4.5l.947-1.894A2 2 0 019.237 0h1.527a2 2 0 011.789 1.106L13.5 3H18v4h-2zm1-3v2H3V4h4.118l1.224-2.447A1 1 0 019.236 1h1.528a1 1 0 01.894.553L12.882 4H17zM5 17a1 1 0 001 1h8a1 1 0 001-1V7H5v10z" /></svg>;